<template lang="pug">
b-modal#modal-ui-element-script(title='貼り付け用タグを取得')
  .callout.callout-info
    p 以下のタグを設置したいページに貼り付けてください
  .row
    textarea.form-control(rows=5)
      | <script type="text/javascript" charset="utf-8" src="{{$store.state.ui_element.url}}"></script>
      | <div id="kenga_countdown_{{$store.state.ui_element.token}}"></div>
</template>

<script>
import Vue from 'vue'

export default {
  methods: {
  },
  components: {
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
